import { NgModule } from '@angular/core';
import { WebSearchResultItemComponent } from './web-search-results-item/web-search-results-item.component';
import { ResultsModule } from '../results/results.module';
import { WebSearchComponent } from './web-search.component';
import { StocksPipe } from './web-search-results-item/stocks.pipe';

const comps = [WebSearchResultItemComponent, WebSearchComponent];

@NgModule({
  declarations: [comps, StocksPipe],
  imports: [ResultsModule],
  providers: [StocksPipe],
  exports: [comps],
})
export class WebSearchModule {}
